// El control `‹ 1 / N ›` de la barra de herramientas de la tabla (`.pagination` del mock).
import { cn } from '@/lib/cn';
import {
    NEXT_PAGE_LABEL,
    PAGER_GROUP_LABEL,
    PREV_PAGE_LABEL,
    type TablePagerState,
} from './tablePaging';

export type TablePagerProps = Pick<TablePagerState<unknown>, 'page' | 'pageCount' | 'setPage'> & {
    className?: string;
};

const ARROW =
    'inline-flex h-[22px] w-[22px] flex-none items-center justify-center rounded-[4px] border border-border bg-card hover:bg-accent aria-disabled:cursor-not-allowed aria-disabled:opacity-40 aria-disabled:hover:bg-card';

export function TablePager({ page, pageCount, setPage, className }: TablePagerProps) {
    const isFirst = page <= 0;
    const isLast = page >= pageCount - 1;

    // `aria-disabled` y no `disabled`: la flecha sigue enfocable, así que el lector de pantalla la
    // encuentra y anuncia que ya no hay más páginas de ese lado.
    return (
        <div
            role="group"
            aria-label={PAGER_GROUP_LABEL}
            className={cn('flex flex-none items-center gap-1 text-[11px]', className)}
        >
            <button
                type="button"
                aria-label={PREV_PAGE_LABEL}
                aria-disabled={isFirst}
                className={ARROW}
                onClick={() => {
                    if (isFirst) return;
                    setPage(page - 1);
                }}
            >
                <span aria-hidden="true">‹</span>
            </button>
            <span className="tabular-nums">{`${String(page + 1)} / ${String(pageCount)}`}</span>
            <button
                type="button"
                aria-label={NEXT_PAGE_LABEL}
                aria-disabled={isLast}
                className={ARROW}
                onClick={() => {
                    if (isLast) return;
                    setPage(page + 1);
                }}
            >
                <span aria-hidden="true">›</span>
            </button>
        </div>
    );
}
